/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LookupValue } from './LookupValue';
import {
    LookupValueFromJSON,
    LookupValueFromJSONTyped,
    LookupValueToJSON,
    LookupValueToJSONTyped,
} from './LookupValue';

/**
 * 
 * @export
 * @interface LookupEntity
 */
export interface LookupEntity {
    /**
     * 
     * @type {string}
     * @memberof LookupEntity
     */
    key: string;
    /**
     * 
     * @type {LookupValue}
     * @memberof LookupEntity
     */
    value: LookupValue;
}

/**
 * Check if a given object implements the LookupEntity interface.
 */
export function instanceOfLookupEntity(value: object): value is LookupEntity {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function LookupEntityFromJSON(json: any): LookupEntity {
    return LookupEntityFromJSONTyped(json, false);
}

export function LookupEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': LookupValueFromJSON(json['value']),
    };
}

export function LookupEntityToJSON(json: any): LookupEntity {
    return LookupEntityToJSONTyped(json, false);
}

export function LookupEntityToJSONTyped(value?: LookupEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': LookupValueToJSON(value['value']),
    };
}

